import { ProductSortToggleForm } from "./product-sort-toggle-form";
import { ProductSortToggleHandler } from "./product-sort-toggle-handler";
import { ProductSortToggleListener } from "./product-sort-toggle-listener";

export class ProductSortToggleSetup {
    public static init(root: HTMLElement): void {
        if (root.dataset.productSortToggleInit === "1") return;
        root.dataset.productSortToggleInit = "1";

        const form = new ProductSortToggleForm(root);
        const input = form.getInput();
        if (!(input instanceof HTMLInputElement)) return;

        const handler = new ProductSortToggleHandler();
        const listener = new ProductSortToggleListener(handler);
        listener.register(input);
    }
}
